module.exports = __webpack_public_path__ + "img/un.52381283.svg";